import { Stack, useTheme } from "@mui/material";
import { type FC, useRef } from "react";
import { ExpandToggleButton } from "web_myplann/Shared/Components/ExpandToggleButton";
import { MultiLineText } from "web_myplann/Shared/Components/MultiLineText";
import { MyPlannHtmlContent } from "web_myplann/Shared/Components/MyPlannHtmlContent";
import { useTextTruncation } from "web_myplann/Shared/Hooks/useTextTruncation";
import {
	getHtmlContentSx,
	isHtmlContent,
} from "web_myplann/Shared/Utils/htmlContentUtils";

type Props = {
	label: string | null | undefined;
	text: string | null | undefined;
	maxLines?: number;
};

export const DataNote: FC<Props> = ({ label, text, maxLines = 4 }) => {
	const theme = useTheme();
	const textRef = useRef<HTMLDivElement>(null);
	const { isTruncated, isExpanded, toggleExpanded } = useTextTruncation(
		textRef,
		[text],
	);

	if (!text) {
		return null;
	}

	return (
		<Stack direction="column" alignItems="left" gap={0.5} py={0.4}>
			<MultiLineText
				variant="deprecatedBody1"
				color={theme.palette.deprecated.grey[500]}
			>
				{label}
			</MultiLineText>

			{isHtmlContent(text) ? (
				<MyPlannHtmlContent
					ref={textRef}
					html={text}
					sx={getHtmlContentSx({ theme, showMore: isExpanded, maxLines })}
				/>
			) : (
				<MultiLineText
					ref={textRef}
					variant="deprecatedBody1"
					color={theme.palette.deprecated.grey[700]}
					clamp={isExpanded ? undefined : maxLines}
				>
					{text}
				</MultiLineText>
			)}

			{(isTruncated || isExpanded) && (
				<ExpandToggleButton
					isExpanded={isExpanded}
					onClick={toggleExpanded}
					fontSize={14}
				/>
			)}
		</Stack>
	);
};
